import React from 'react';
import { Section } from './ui/Section';
import { useCountUp } from '../hooks/useCountUp';
import { motion } from 'framer-motion';
export default function PainSection() {
  return <Section className="bg-brand-charcoal relative overflow-hidden" data-id="element-266">
      {/* Subtle anxiety gradient wash */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 1.5
    }} className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-dark/30 to-transparent pointer-events-none" data-id="element-267" />

      {/* Abstract soft blobs */}
      <div className="absolute -right-20 -top-20 w-72 h-72 bg-brand-indigo/5 rounded-full blur-3xl pointer-events-none" data-id="element-268" />
      <div className="absolute -left-16 bottom-0 w-56 h-56 bg-brand-amber/5 rounded-full blur-3xl pointer-events-none" data-id="element-269" />

      <div className="relative z-10" data-id="element-270">
        <h2 className="font-heading text-4xl md:text-5xl text-white mb-12 text-center uppercase tracking-wide" data-id="element-271">
          El verdadero problema no es el insomnio.{' '}
          <span className="text-brand-amber" data-id="element-272">Es el miedo a no dormir.</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-273">
          <div className="space-y-6" data-id="element-274">
            <p className="text-xl text-slate-400" data-id="element-275">
              Cuando tu cerebro asocia la cama con:
            </p>
            <ul className="space-y-4" data-id="element-276">
              {['pelear,', 'pensar,', 'preocuparse,', 'y frustrarse.'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center text-2xl md:text-3xl font-heading text-slate-200 uppercase tracking-wide" data-id="element-277">
                    <span className="w-3 h-3 bg-brand-indigo rounded-full mr-4 shadow-[0_0_12px_rgba(67,56,202,0.6)] animate-pulse" data-id="element-278" />
                    {item}
                  </motion.li>)}
            </ul>
          </div>

          <div className="bg-brand-dark/50 p-8 rounded-2xl border border-white/10 shadow-lg backdrop-blur-sm" data-id="element-279">
            <p className="text-xl md:text-2xl text-slate-400 leading-relaxed mb-6" data-id="element-280">
              Tu sistema nervioso entra en modo alerta cada vez que ves la
              almohada.
            </p>
            <p className="text-xl md:text-2xl text-slate-200 font-medium leading-relaxed" data-id="element-281">
              La cama se vuelve un{' '}
              <span className="text-brand-indigo font-bold" data-id="element-282">
                campo de batalla
              </span>
              . Y en una guerra, nadie duerme.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}